export const en = {
  common: {
    ok: "OK",
    cancel: "Cancel",
    close: "Close",
    copy: "Copy",
    share: "Share",
    copied: "Link copied!",
    loading: "Loading…",
    required: "Required",
    optional: "optional",
    passwordTooShort: "Password must be at least 8 characters",
    cookies: "Cookies",
    privacy: "Privacy Policy",
    terms: "Terms & Conditions",
    contact: "Contact",
    reportIssue: {
      title: "Report an Issue",
      descriptionLabel: "Describe the issue or idea",
      descriptionPlaceholder: "Tell us what went wrong or share your idea...",
      stepsLabel: "Steps to reproduce (optional)",
      stepsPlaceholder: "List the steps so we can see the problem",
      screenshotLabel: "Screenshot (optional)",
      submit: "Submit report",
      error: "Couldn't submit: {{error}}",
      success: "Thanks! We've received your report.",
    },
    testimonialsTitle: "What our users say",
    testimonial1: "Anemi Meets saves me so much time! — Sophie, Rotterdam",
    freeAccountInfo:
      "With a free account you can instantly plan Meetups and send invites!",
    alreadyHaveAccount: "Already have an account? Login",
    createAccount: "Create Account",
    error_invalid_email: "Please enter a valid email address",
    morning: "Morning",
    afternoon: "Afternoon",
    evening: "Evening",
    date: "Date",
    cookiesFull:
      "Anemi Meets uses only functional cookies necessary for the site to work. By continuing you accept these cookies.",
    privacyFull:
      "We only collect the details you enter to plan meetups. This information is never shared with third parties and is used solely to provide our service.",
    termsFull:
      "By using Anemi Meets you agree to use the service responsibly. Accounts that abuse the platform may be suspended.",
    rights: "All rights reserved.",
    lastUpdate: "Last updated:",
    contactIntro: "Feel free to reach out using the form below.",
    contactName: "Your name",
    contactEmail: "Your email",
    contactMessage: "Your message",
    contactSend: "Send",
    contactSuccess: "Thanks for your message! We'll get back to you soon 😊",
    contactError: "Oops! Something went wrong. Please try again.",
    namePlaceholder: "Your name",
    emailPlaceholder: "Enter your email address",
    messagePlaceholder: "Type your message here...",
  },
  navigation: {
    home: "Home",
    explore: "Explore Cafés",
    plan: "Plan Meetup",
    dashboard: "Dashboard",
    account: "My Account",
    login: "Login",
    logout: "Logout",
  },
  home: {
    title: "Discover cafés & meet friends",
    subtitle: "100 % free · no account needed",
    ctaExplore: "Find cafés",
    ctaPlan: "Plan a meetup",
    howItWorksTitle: "How it works",
    hiw_step1: "Choose a city",
    hiw_step2: "Pick dates",
    hiw_step3: "Share the link",
    testimonial: "“Meeting up is finally simple again!”",
    fillIn: "Fill in your details",
    fillInDesc: "Let us know who you are and when you're free.",
    send: "Send invite",
    sendDesc: "Share the link with your friend in one click.",
    accept: "Accept",
    acceptDesc: "Your friend picks a time and confirms. Done!",
    tired: "Tired of endless group chats?",
    oneClick: "One click and you're done!",
    connectFaster: "Connect faster, meet sooner!",
    strengthen: "Strengthen your connections",
    firstStep: "Take the first step to a real meetup!",
    startNow: "Start now",
    freeText: "It's 100% free, no account needed!",
  },
  createMeeting: {
    title: "Plan a meetup",
    step1_title: "Your info",
    step1_sub: "Let your friend know who's inviting them.",
    step2_title: "City",
    step2_sub: "Where would you like to meet?",
    step3_title: "When",
    step3_sub: "Pick your available dates & times.",
    step4_title: "Café",
    step4_sub: "We'll suggest a cosy spot.",
    step5_title: "Confirm",
    step5_sub: "Review and create your invite.",
    btn_submit: "Create invite",
    chooseCity: "Choose your city",
    chooseCityInfo:
      "Choose your city! That way we know where to find the best spots for you.",
    chooseCityLabel: "Which city do you want?",
    chooseDaysInfo: "Pick as many days as you like! The more, the merrier ☀️",
    chooseDates: "Pick your dates",
    chooseTimes: "Pick your preferred times for each date",
    chooseCafe: "Pick your café!",
    summary: "Summary",
    name: "Name",
    city: "City",
    cafe: "Café",
    selectedDates: "Selected dates",
    errorNameShort: "Your name is too short",
    errorEmailInvalid: "Please enter a valid email address",
    errorEmailRequired: "Email is required",
    errorNameRequired: "Name is required",
    errorCityRequired: "City is required",
    errorDatesRequired: "Please select at least one date",
    errorTimesRequired: "Please select at least one time slot",
    errorCafeRequired: "Please choose a café",
    suggestionName: "Try a fun or creative nickname",
  },
  invite: {
    titleStepCloser: "You're almost there! 🎉",
    detailsHeading: "Here are the details for your meetup!",
    shareInstructions:
      "Share this link with your friend and let the coffee magic happen! ☕✨",
    share: "Share the magic! ✨",
    copyLink: "Copy link & send! 📋",
    cafeInfoPending: "Café will be revealed soon! Stay tuned!",
    copySuccess: "Link copied! Go spread the coffee joy! ☕️🎉",
    copyError:
      "Oops, copying failed! Try again or just shout the link across the room!",
    copy: "Copy link",
  },
  respond: {
    title: "You've got a coffee invite! ☕️🥳",
    subtitle:
      "Pick a time, fill in your email, and get ready for a cozy meetup at a local café!",
    explanation:
      "Your friend wants to meet up for coffee at a local spot. Just pick a time that works for you, enter your email, and we'll handle the rest. Supporting local coffee shops, one meetup at a time! ☕️❤️",
    timeLabel: "Pick a time slot:",
    emailLabel: "Your email",
    emailPlaceholder: "you@example.com",
    updatesOptIn: "Keep me updated about Anemi Meets",
    btn_confirm: "Confirm meetup",
    success_title: "Meetup confirmed!",
    invalid_link: "This invitation link is invalid or expired.",
  },
  meetup: {
    errorEmailRequired: "Email is required",
    chooseCityLabel: "Which city do you want?",
    chooseCafeInfo: "Shuffle for a surprise café!",
    noCafeMatch: "Oops! We couldn't find a café that matches your preferences. Maybe try relaxing your filters, or just go wild and pick any spot! ☕️✨",
  },
  dashboard: {
    title: "Your Dashboard",
    welcome: "Hey there",
    user: "friend",
    lastLogin: "Last seen: {{date}}",
    lastActivity: "Last fun meetup:",
    upcomingMeetups: "Your next meetups",
    noMeetups: "No meetups yet. Time to plan some fun! ☕️🎉",
    ctaNewMeetup: "Plan something new!",
    ctaProfile: "Edit profile",
    ctaLogout: "Log out",
    errorLoadingMeetups: "Oops, couldn't load your meetups. Try again!",
    hasAccount: "Has account",
    noAccount: "No account",
    inviteToMeetup: "Invite to meetup",
    searchFriends: "Search friends",
  },
  account: {
    title: "Your Profile",
    profileInfo: "About you",
    name: "Name",
    email: "Email",
    emoji: "Pick your vibe",
    age: "How old are you?",
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    changeName: "Change your name",
    changeEmail: "Change your email",
    nameEditHint: "Want a cooler name? Change it here!",
    emailEditHint: "Wrong email? Fix it!",
    ageEditHint: "How young do you feel? Type it in!",
    wantsUpdates: "Send me fun updates!",
    wantsUpdatesCheckbox: "Yeah, I want to receive updates!",
    wantsReminders: "Send me meetup reminders",
    wantsRemindersCheckbox: "Yes, remind me before a meetup!",
    wantsNotifications: "Browser notifications",
    wantsNotificationsCheckbox: "Yes, allow browser notifications!",
    isPrivate: "Keep my profile private",
    isPrivateCheckbox: "Yeah, I want to keep my profile private!",
    dangerZone: "Danger Zone",
    deleteAccount: "Delete my account",
    deleteConfirm: "Are you sure? This can't be undone!",
    confirmDelete: "Yes, delete everything",
    logout: "Log out",
    saving: "Saving...",
    notSpecified: "Not yet filled in",
    errorSession: "Oops, something went wrong. Please log in again!",
    status: {
      confirmed: "Confirmed",
      pending: "Pending",
      cancelled: "Cancelled",
      declined: "Declined",
    },
    contactPerson: "Contact person",
    unknownContact: "Unknown contact",
    password: "Change your password",
    changePassword: "Update password",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmPassword: "Confirm new password",
    passwordChangeSuccess: "Password changed successfully!",
    myMeetups: "Your meetups (let's get social!)",
    errorLoadingMeetupsDetails:
      "Oops! Couldn't load your meetups. Try again or refresh.",
    pastMeetups: "Past meetups",
    personalInvite: "Your personal invite link",
    copyInvite: "Copy link",
    inviteHint:
      "Share this link with friends so they can instantly connect with you!",
    yourBadges: "Your Badges",
    locked: "Locked",
  },
  toast: {
    profileUpdated: "Profile updated!",
    signupSuccess: "Account created! You're all set! ✨",
  },
  sessionExpiresSoon: "Your session will expire soon. Please log in again.",

  login: {
    title: "Ready to log in? 👋",
    subtitle: "Ready for more coffee adventures? Log in below!",
    welcomeBack: "You're in! ☕️",
    welcomeDesc: "Pop in your details and let's get you back to your meetups.",
    forgotPassword: "Forgot your password? Oops!",
    noAccountCta: "No account yet? Join the fun in seconds!",
    error_generic: "Hmm, that didn't work. Try again?",
    error_user_not_found: "Can't find that email. Did you type it right?",
    error_invalid_password: "That combo doesn't look right. Try again!",
    error_invalid_email: "That email looks a bit off. Double-check it!",
    error_user_banned: "This account is blocked. Need help? Contact us!",
    error_email_not_confirmed: "Check your inbox to confirm your email first!",
    errorRateLimit:
      "Whoa, slow down! Too many tries. Wait a sec and try again.",
    reset_error_generic: "Couldn't send the reset email. Try again?",
    reset_success: "Reset email sent! Time for a new password and a fresh cup of coffee ☕️. Check your inbox!",
    toast: {
      loginSuccess: "Woohoo, you're in! 🎉",
    },
    emailPlaceholder: "Your email address",
    emailLabel: "Your email address",
    passwordLabel: "Your password",
    passwordPlaceholder: "Your super secret password",
    loginButton: "Let me in!",
    googleButton: "Continue with Google",
  },
  signup: {
    title: "Sign up",
    subtitle: "Create your free account to get started",
    namePrompt: "We're glad you're here! What should we call you?",
    namePlaceholder: "Your name",
    emailPrompt: "Which email address can we use to connect you?",
    emailPlaceholder: "Your email address",
    passwordPrompt: "Which password do you want to use for this account?",
    passwordPlaceholder: "Your password",
    confirmPasswordPrompt:
      "Sorry, but we need to check if you typed your password correctly",
    confirmPasswordPlaceholder: "Confirm your password",
    overviewTitle: "Overview of your details",
    submit: "Sign up",
    steps: ["Name", "Email", "Password", "Overview"],
  },
  onboarding: {
    welcome: {
      title: "Welcome to Anemi Meets!",
      description:
        "Plan meetups with friends in a few clicks. We'll show you how!",
    },
    features: {
      title: "Easy planning",
      description:
        "Pick a city, a date, and invite your friends. We'll handle the rest!",
    },
    getting_started: {
      title: "Ready to go?",
      description: "Let's create your first meetup! Let's go!",
    },
  },
  skip: "Skip",
  get_started: "Let's go! 🚀",
  next: "Next",
};
